import { render, staticRenderFns } from "./Bulk.vue?vue&type=template&id=5d2ae528&"
import script from "./Bulk.vue?vue&type=script&lang=js&"
export * from "./Bulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports